import axios from "axios";

const api = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	withCredentials: true,
});

export const openApi = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL
	
});

// Busca status da conexão do WhatsApp
export const getWhatsappConnectionStatus = async (whatsappId) => {
	const response = await api.get(`/whatsapp/${whatsappId}`);
	return response.data.status;
};

export const updateTicketStatus = async (ticketId, newStatus) => {
  return api.put(`/tickets/${ticketId}, { status: newStatus }`);
};


export default api;
